/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".email-address[_ngcontent-%COMP%]{left:0!important;right:0!important;margin:auto!important;width:60%!important}"];
export { styles as styles };
